import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_DAILY_REPORTS_API_, RQ_GET_NEW_DAILY_REPORTS_API} from '@app/reactQuery/apis/constants';

export const RQUseGetDailyReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_daily_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, entityTagId, callTypeId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DAILY_REPORTS_API_,
        null,
        certificate,
        {
          locationId: locationId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
          entityTagId: entityTagId,
          callTypeId: callTypeId,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetNewDailyReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_new_daily_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, entityTagId, callTypeId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_NEW_DAILY_REPORTS_API,
        null,
        certificate,
        {
          locationId: locationId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
          entityTagId: entityTagId,
          callTypeId: callTypeId,
        },
        signal,
      );
    },
    ...options,
  });
};
